var map = {
	"./1.png": "079f",
	"./10.png": "c9d5",
	"./2.png": "34bb",
	"./3.png": "e2b9",
	"./4.png": "164a",
	"./5.png": "7247",
	"./6.png": "2781",
	"./7.png": "3abf",
	"./8.png": "6336",
	"./9.png": "ae10",
	"./direct.png": "44f3",
	"./icon-next.png": "585d",
	"./not-direct.png": "c30b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7116";